var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AppleIconplant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.81,42.68C93.61,55.19,96.93,84.55,118.72,94c-5.39,11.51-11.28,22.62-21.58,30.59-4.94,3.83-10.68,4.54-16.25,1.73-10-5.05-19.67-4.75-29.69,0-7,3.34-13.59,1.49-19.14-3.62C24,115.25,18.44,106,14.38,95.92,9.24,83.18,7,70,10.19,56.38c3.29-14,14.89-24.83,29.12-26.26A30.47,30.47,0,0,1,53,32.26c8.69,3.43,16.71,3.36,25.48-.14C92.2,26.65,105.32,30.91,114.81,42.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.75,0c2.16,14.42-9.82,29.64-23.62,30.79-2.31.19-2.57-.93-2.56-2.66C61.62,20,65,13.35,70.76,7.9A27.72,27.72,0,0,1,87.75,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.66ff019868b26b753af0b129e95332ee.svg";
export { ForwardRef as ReactComponent };